import { Component } from "preact";
import common from "./common";

class I18NUtils extends Component {
  i18n = {};

  getKey(key) {
    if (common.isNullOrUndefined(key)) return "";

    const msg = key.split(/\.(.+)/);
    /*
        if(!this.i18n[msg[0]]){
        //do async handling
        this.loadBundle(msg[0]);
        }
        */
    const a = this.i18n[msg[0]];
    return (a && a[msg[1]]) || !1;
  }

  load(data) {
    this.i18n = data;
  }
}
export const i18nUtils = new I18NUtils();
export const locale = i18nUtils.getKey.bind(i18nUtils);



// WEBPACK FOOTER //
// ./utils/i18n.js